module.exports = __webpack_public_path__ + "img/View Birch Equipment Locations.f9a02a07.jpeg";